<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
      <el-text-field
        :required="requestNumberRequired"
        :disabled="numberDisabled"
        label="Pranešimo numeris"
        v-model="formData.request_number"
        :maxlength="40"
      />
    </v-col>
    <v-col class="pb-0 -0 pt-0" cols="12" md="6" lg="3" v-if="showRequestDate()">
      <el-date-picker
        disabled
        label="Pranešimo data"
        v-model="formData.request_date"
      />
    </v-col>
    <v-col class="pb-0 -0 pt-0" cols="12" md="6" lg="3">
      <el-text-field
        disabled
        label="Pranešimo būsena"
        :value="getStatus"
      />
    </v-col>
    <v-col class="pb-0 -0 pt-0" cols="12" md="6" lg="3" v-if="formData.pas_request_number">
      <el-text-field
        disabled
        label="PAS prašymo numeris"
        :value="formData.pas_request_number"
      />
    </v-col>
  </v-row>
</template>

<script>
  import Enums from '@/enums'
  import InJournalStatuses from '@/components/constants/inJournalStatus'
  import Roles from '@/components/constants/roles'

  export default {
    name: 'MewssageDetails',
    components: {},
    props: {
      formData: [Array, Object],
      isErrorsCorrection: Boolean,
      onlyView: Boolean
    },
    created() {},
    computed: {
      requestNumberRequired() {
        if(this.isErrorsCorrection){
          return false        }
        const userRoles = this.$store.getters.userRole;
        return !(userRoles.includes(Roles.NOTARAS) || userRoles.includes(Roles.NOT_PAD) || userRoles.includes(Roles.NOT_PAD2))
      },
      numberDisabled() {
        if(this.isErrorsCorrection){
          return true
        }
        const userRoles = this.$store.getters.userRole;
        return this.onlyView || userRoles.includes(Roles.NOTARAS) || userRoles.includes(Roles.NOT_PAD) || userRoles.includes(Roles.NOT_PAD2);
      },
      getStatus(){
        let statuses = this.$i18n.locale === 'lt' ? Enums.journalType.lt : Enums.journalType.en
        return statuses[this.formData.status]
      },
    },
    methods: {
      showRequestDate() {
        return this.formData.status != InJournalStatuses.RENGIAMAS
      }
    }
  }
</script>

<style></style>
